<template>
  <div class="px-4">
    <h2 class="sm:pt-12 text-2xl font-extrabold tracking-normal text-center text-black sm:text-4xl">
      <slot></slot>
    </h2>

    <p
      v-if="hasDescriptionSlot"
      class="pb-5 sm:pb-12 mt-3 text-base sm:text-2xl font-semibold text-center text-gray-800"
    >
      <slot name="description"></slot>
    </p>
  </div>
</template>

<script>
export default {
  computed: {
    hasDescriptionSlot() {
      return !!this.$slots.description
    },
  },
}
</script>
